"use client";

import { Box, Button } from "@chakra-ui/react";
import GenericIcon from "@/shared/ui/actions/GenericIcon";

interface SearchLoadMoreButtonProps {
  onClick: () => void;
}

export default function SearchLoadMoreButton({
  onClick,
}: SearchLoadMoreButtonProps) {
  return (
    <Box display="flex" justifyContent="center">
      <Button
        size={{
          base: "xs",
          sm: "sm",
          md: "md",
        }}
        w="32"
        borderRadius="md"
        onClick={onClick}
        mt="4"
        bg="moveon.secondaryLight"
      >
        <GenericIcon icon="expand_more" />
        Load more
        <GenericIcon icon="expand_more" />
      </Button>
    </Box>
  );
}
